import React from "react";
import { motion } from "framer-motion";
import PhoneDemo from "../../PhoneDemo";

const STAGE_CONFIG = {
  1: { scale: 1.0 },
  2: { scale: 0.92 },
  3: { scale: 0.82 },
  4: { scale: 0.88 },
  5: { scale: 0.78 },
};

const BASE_RENDER_WIDTH  = PhoneDemo.WIDTH;
const BASE_RENDER_HEIGHT = PhoneDemo.HEIGHT;

const DISPLAY_WIDTH  = 248;
const DISPLAY_HEIGHT = 512;
const INNER_SCALE    = DISPLAY_WIDTH / BASE_RENDER_WIDTH;

export default function PhoneAnchor({
  stage = 1,
  enabledServices,
  hostLogo,
  compactHeight = false,
}) {
  const cfg = STAGE_CONFIG[stage] || STAGE_CONFIG[1];
  const scaleClass = compactHeight
    ? "scale-[0.5] tabletOnly:scale-[0.64] laptop:scale-[0.82] desktop:scale-[0.9]"
    : "scale-[0.62] tabletOnly:scale-[0.78] laptop:scale-100";

  return (
    <div className="relative flex items-center justify-center w-full h-full min-h-0">
      <div className={`origin-center transition-transform ${scaleClass}`}>
      <motion.div
        layoutId="concierge-phone"
        animate={{ scale: cfg.scale }}
        transition={{ layout: { duration: 0.6, ease: [0.22, 0.61, 0.36, 1] }, scale: { duration: 0.45, ease: "easeOut" } }}
        style={{
          width: DISPLAY_WIDTH,
          height: DISPLAY_HEIGHT,
          borderRadius: 38,
          background: "#000",
          border: "1px solid rgba(0,0,0,0.12)",
          boxShadow: "0 30px 80px rgba(0,0,0,0.15), 0 10px 30px rgba(0,0,0,0.1)",
          position: "relative",
          overflow: "hidden",
          transformOrigin: "center",
        }}
      >
        <PhoneSurface enabledServices={enabledServices} hostLogo={hostLogo} />
      </motion.div>
      </div>
    </div>
  );
}

function PhoneSurface({ enabledServices, hostLogo }) {
  return (
    <>
      <div
        style={{
          position: "absolute",
          top: 7,
          left: "50%",
          transform: "translateX(-50%)",
          width: 76,
          height: 22,
          borderRadius: 12,
          background: "#000",
          zIndex: 20,
        }}
      />
      <div
        style={{
          position: "absolute",
          top: 4,
          left: 4,
          right: 4,
          bottom: 4,
          borderRadius: 34,
          overflow: "hidden",
          background: "#fff",
        }}
      >
        <div
          style={{
            width: BASE_RENDER_WIDTH,
            height: BASE_RENDER_HEIGHT,
            transform: `scale(${INNER_SCALE})`,
            transformOrigin: "top left",
          }}
        >
          <PhoneDemo enabledServices={enabledServices} hostLogo={hostLogo} />
        </div>
      </div>
    </>
  );
}

PhoneAnchor.DISPLAY_WIDTH = DISPLAY_WIDTH;
PhoneAnchor.DISPLAY_HEIGHT = DISPLAY_HEIGHT;
